import { render, staticRenderFns } from "./AdminSports.vue?vue&type=template&id=0eb5bb36"
import script from "./AdminSports.vue?vue&type=script&lang=js"
export * from "./AdminSports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports